import {
  UPDATE_FLAVOUR,
  UPDATE_SRP_SEO_FAQ,
  UPDATE_SRP_SEO_DATA,
  UPDATE_SRP_SEO_THOR_DATA,
  UPDATE_JOURNEY_TYPE,
  UPDATE_TRAVEL_TYPE,
  UPDATE_SEARCH_WIDGET_LOCATION,
  UPDATE_SEARCH_WIDGET_DEP_ARR,
  UPDATE_SEARCH_WIDGET_PAX,
  UPDATE_SEARCH_WIDGET_FLIGHT_CLASS,
  UPDATE_SEARCH_WIDGET_SWAP_SOURCE_DESTINATION,
  UPDATE_MODIFY_SEARCH_WIDGET,
  UPDATE_SELECTED_FLIGHT,
  UPDATE_MINFARE_DATA,
  UPDATE_QUERY_PARAMS_FROM_URL,
  UPDATE_OFFER_DATA,
  UPDATE_FARE_CALENDAR_DATA,
  UPDATE_FARE_TRENDS_DATA,
  UPDATE_SEO_LANGUAGE,
  SET_COMMON_FARE_RULES,
  APPLY_STUDENT_FARE_FILTER,
  APPLY_DEFENCE_FARE_FILTER,
  APPLY_SENIOR_CITIZEN_FARE_FILTER,
  SET_BANNER_DETAILS,
  SET_SPECIAL_FARE_OPTIONS,
  SET_SELECTED_FARE_IDENTIFIER,
  SET_EXPERIMENT_DETAILS,
  SET_EXPERIMENT_META_DATA,
  UPDATE_SEARCH_WIDGET_TRAVEL_DATE,
  UPDATE_SEARCH_WIDGET_TRIP_DURATION,
  UPDATE_SEARCH_WIDGET_ANY_TIME,
  UPDATE_SELECTED_DESTINATION,
  SORT_DESTINATIONS,
  SORT_FLIGHTS,
  APPLY_FITLERS,
  UPDATE_ANYWHERE,
  ADD_STATIC_INFORMATION,
  UPDATE_THOR_HIT_ERR_MSG,
  ADD_CORRELATION_ID_FOR_LOGGING,
  UPDATE_THOR_DATA,
  UPDATE_DEPARTURE,
  UPDATE_ARRIVAL,
  SET_UUID,
  UPDATE_SRP_SEO_THOR_DATA_GROUND_UP,
  SET_PRE_SEARCH_BANNER_DETAILS,
  SET_SELECTED_BANNER_DETAILS
} from './actions';
const TODAY = new Date();
const PASSENGERS = { adult: 1, child: 0, infant: 0 };
const FLIGHT_CLASS_OBJECT: Array<object> = [{ value: 'E', name: 'Economy' }];
const FLIGHT_CLASS = FLIGHT_CLASS_OBJECT[0];
const JOURNEY_TYPE = 'ow';
const TRAVEL_TYPE = 'domestic';
import getDateObject from '@stencil/flights-date-utils/src/get-date-object';
import addDays from '@stencil/date-utils/src/addDays';
import {
  stopsFilterFunction,
  showCountriesFilterFunction,
  priceFilterFunction,
  durationFilterFunction,
  famousForFilterFunction
} from '../../utils/filterUtils';

export const defaultCityCountryFilterSettings = {
  showCountries: {
    values: [],
    filterFunc: showCountriesFilterFunction
  },
  onwardStops: {
    values: [],
    filterFunc: stopsFilterFunction
  },
  price: {
    values: [],
    filterFunc: priceFilterFunction
  },
  duration: {
    values: [],
    filterFunc: durationFilterFunction
  },
  famousFor: {
    values: [],
    filterFunc: famousForFilterFunction
  }
};

export const defaultSortSettings = {
  currentSort: 'cheapest',
  isAscending: true,
  previousSortType: ''
};

export const initialState = {
  srcCity: '',
  destCity: '',
  city: '',
  country: '',
  countryId: '',
  flavour: '',
  queryType: '',
  airline: '',
  cacheBurst: false,
  source: {},
  destination: {},
  departure: getDateObject(TODAY),
  arrival: null,
  passengers: PASSENGERS,
  flightClass: FLIGHT_CLASS,
  journeyType: JOURNEY_TYPE,
  travelType: TRAVEL_TYPE,
  srcArticle: {},
  hotels: [],
  htl_city_links: [],
  popular_hotels: [],
  selectedFlight: {},
  hasSeoData: false,
  offers: [],
  modifySearchWidget: {
    isOpen: false,
    isSubOpen: false
  },
  minfare: {
    minToday: '',
    minIn30Days: ''
  },
  fareCalendarData: null,
  fareTrendsData: null,
  searchWidget: {
    source: {},
    destination: {},
    departure: getDateObject(addDays(TODAY, 3)),
    arrival: null,
    passengers: PASSENGERS,
    flightClass: FLIGHT_CLASS,
    journeyType: JOURNEY_TYPE,
    travelType: TRAVEL_TYPE,
    isStudentFare: false,
    isDefenceFare: false,
    isSeniorCitizenFare: false,
    isAnywhere: false,
    anyTime: true,
    travelDate: getDateObject(new Date()),
    tripDuration: 14
  },
  faqs: [],
  language: 'english',
  commonFareRulesData: {},
  bannerDetails: {},
  specialFareOptions: null,
  fareOptionsInfo: {},
  selectedFareIdentifier: '',
  experimentDetails: [],
  experimentMetaData: null,
  filterSettings: defaultCityCountryFilterSettings,
  selectedDestination: {},
  sortSettings: defaultSortSettings,
  sortFlightSettings: defaultSortSettings,
  chunks: {
    prefetchChunks: false,
    allChunks: false
  },
  //thor
  unorderedChunks: {},
  numberOfData: 0,
  dataIndex: 0,
  staticInformation: {},
  onwardFlights: [],
  returnFlights: [],
  airports: [],
  carriers: [],
  aircrafts: [],
  dates: [],
  ibp: [],
  refundability: [],
  messageText: [],
  messageValues: [],
  messageIcons: [],
  discountFares: [],
  discountNames: [],
  discountMessages: [],
  displayOnwardFlights: [],
  displayReturnFlights: [],
  terminalInfo: [],
  multiIndex: [],
  promotionText: [],
  similarFlights: [],
  discounts: [],
  alternateTimeFlights: [],
  alternateLocationFlights: [],
  displayAlternateTimeFlights: [],
  displayAlternateLocationFlights: [],
  filterMinMaxValues: {
    carriers: {}
  },
  uuid: '',
  preSearchBannerDetails: null,
  thorGroundUpData: {},
  selectedBannerIndex: {
    bannerPositionIndex: null,
    horizontalIndex: null
  }
};

export default function seoReducer(state = initialState, action) {
  const { type, props } = action;

  switch (action.type) {
    case UPDATE_FLAVOUR:
    case UPDATE_QUERY_PARAMS_FROM_URL:
      return {
        ...state,
        ...action.actionData
      };
    case UPDATE_SRP_SEO_FAQ:
      return {
        ...state,
        faqs: action.actionData
      };
    case UPDATE_OFFER_DATA:
      return {
        ...state,
        offers: action.actionData
      };
    case UPDATE_SRP_SEO_DATA:
      return {
        ...state,
        ...action.actionData,
        fareCalendarData: action.actionData.fareCalendarData,
        fareTrendsData: action.actionData.fareCalendarData,
        searchWidget: {
          ...state.searchWidget,
          source: action.actionData.source,
          destination: action.actionData.destination,
          travelType: action.actionData.sectorType,
          ...(action.actionData.journeyType
            ? { journeyType: action.actionData.journeyType }
            : null),
          ...(action.actionData.journeyType === 'rt'
            ? { arrival: getDateObject(addDays(TODAY, 7)) }
            : null)
        }
      };
    case UPDATE_SRP_SEO_THOR_DATA:
      return {
        ...state,
        ...action.actionData
      };
    case UPDATE_SRP_SEO_THOR_DATA_GROUND_UP:
      return {
        ...state,
        thorGroundUpData: action.actionData
      };
    case APPLY_FITLERS:
      return {
        ...state,
        filterSettings: action.actionData
      };
    case UPDATE_THOR_DATA:
      // const chunkIndex = action.actionData.chunk.n[9];
      const chunkIndex1 = action.actionData.chunk.n[9];
      return {
        ...state,
        numberOfData: state.numberOfData + 1,
        dataIndex: state.dataIndex + 1,
        onwardFlights: [...action.actionData.onwardFlights],
        returnFlights: [...action.actionData.returnFlights],
        airports: [...action.actionData.airports],
        carriers: [...action.actionData.carriers],
        aircrafts: [...action.actionData.aircrafts],
        dates: [...action.actionData.dates],
        ibp: [...action.actionData.ibp],
        refundability: [...action.actionData.refundability],
        messageText: [...action.actionData.messageText],
        messageValues: [...action.actionData.messageValues],
        messageIcons: [...action.actionData.messageIcons],
        discountFares: [...action.actionData.discountFares],
        discountNames: [...action.actionData.discountNames],
        discountMessages: [...action.actionData.discountMessages],
        // domesticRoundTripDiscounts: {...state.domesticRoundTripDiscounts, ...action.actionData.domesticRoundTripDiscounts},
        displayOnwardFlights: [...action.actionData.displayOnwardFlights],
        displayReturnFlights: [...action.actionData.displayReturnFlights],
        filterMinMaxValues: action.actionData.filterMinMaxValues,
        //CHECK WITH THOR
        ...(action.actionData.brandIds
          ? {
              brandIds: action.actionData.brandIds
            }
          : null),
        ...(action.actionData.brandNames
          ? {
              brandNames: action.actionData.brandNames
            }
          : null),
        ...(action.actionData.terminalInfo
          ? {
              terminalInfo: [...action.actionData.terminalInfo]
            }
          : null),
        ...(action.actionData.multiIndex
          ? {
              multiIndex: action.actionData.multiIndex
            }
          : null),
        ...(action.actionData.promotionText
          ? {
              promotionText: [...action.actionData.promotionText]
            }
          : null),
        ...(action.actionData.similarFlights
          ? {
              similarFlights: [...action.actionData.similarFlights]
            }
          : null),
        ...(action.actionData.discounts
          ? {
              discounts: {
                ...action.actionData.discounts
              }
            }
          : null),
        ...(chunkIndex1 === 0 ? { isStoreEmpty: false } : null),
        ...(action.actionData.alternateTimeFlights
          ? {
              alternateTimeFlights: [...action.actionData.alternateTimeFlights]
            }
          : null),
        ...(action.actionData.alternateLocationFlights
          ? {
              alternateLocationFlights: [...action.actionData.alternateLocationFlights]
            }
          : null),
        ...(action.actionData.displayAlternateTimeFlights
          ? {
              displayAlternateTimeFlights: [...action.actionData.displayAlternateTimeFlights]
            }
          : null),
        ...(action.actionData.displayAlternateLocationFlights
          ? {
              displayAlternateLocationFlights: [
                ...action.actionData.displayAlternateLocationFlights
              ]
            }
          : null),
        ...(action.actionData.showOnePaxPrice
          ? {
              showOnePaxPrice: action.actionData.showOnePaxPrice
            }
          : null),
        ...(action.actionData.paVal ? { paVal: action.actionData.paVal } : null),
        ...(action.actionData.onwardMaxPrice
          ? { onwardMaxPrice: action.actionData.onwardMaxPrice }
          : null),
        ...(action.actionData.onwardMinPrice
          ? { onwardMinPrice: action.actionData.onwardMinPrice }
          : null),
        ...(action.actionData.onwardDuration
          ? { onwardDuration: action.actionData.onwardDuration }
          : null),
        ...(action.actionData.returnMaxPrice
          ? { returnMaxPrice: action.actionData.returnMaxPrice }
          : null),
        ...(action.actionData.returnMinPrice
          ? { returnMinPrice: action.actionData.returnMinPrice }
          : null),
        ...(action.actionData.returnDuration
          ? { returnDuration: action.actionData.returnDuration }
          : null),
        // ...(action.actionData.showPriceLockBanner
        //   ? { showPriceLockBanner: action.actionData.showPriceLockBanner }
        //   : null),
        // ...(action.actionData.staticInformation
        //   ? { staticInformation: action.actionData.staticInformation }
        //   : null),
        ...(action.actionData.correlationIdForLogging
          ? { correlationIdForLogging: action.actionData.correlationIdForLogging }
          : null)
      };
    case UPDATE_FARE_CALENDAR_DATA:
      return {
        ...state,
        fareCalendarData: action.actionData
      };
    case UPDATE_SEO_LANGUAGE:
      return {
        ...state,
        language: action.actionData
      };
    case UPDATE_FARE_TRENDS_DATA:
      return {
        ...state,
        fareTrendsData: action.actionData
      };
    case UPDATE_TRAVEL_TYPE:
      return {
        ...state,
        travelType: action.actionData,
        searchWidget: {
          ...state.searchWidget,
          travelType: action.actionData
        }
      };
    case UPDATE_JOURNEY_TYPE:
    case UPDATE_SEARCH_WIDGET_LOCATION:
    case UPDATE_SEARCH_WIDGET_DEP_ARR:
    case UPDATE_SEARCH_WIDGET_PAX:
    case UPDATE_SEARCH_WIDGET_FLIGHT_CLASS:
    case UPDATE_SEARCH_WIDGET_SWAP_SOURCE_DESTINATION:
    case APPLY_STUDENT_FARE_FILTER:
    case APPLY_DEFENCE_FARE_FILTER:
    case APPLY_SENIOR_CITIZEN_FARE_FILTER:
      return {
        ...state,
        searchWidget: {
          ...state.searchWidget,
          ...action.actionData
        }
      };
    case UPDATE_MODIFY_SEARCH_WIDGET:
      return {
        ...state,
        modifySearchWidget: {
          ...state.modifySearchWidget,
          ...action.actionData
        }
      };
    case UPDATE_SELECTED_FLIGHT:
      return {
        ...state,
        selectedFlight: action.actionData
      };
    case UPDATE_MINFARE_DATA:
      return {
        ...state,
        departure: action.actionData.depDate,
        searchWidget: {
          ...state.searchWidget,
          departure: action.actionData.depDate
        },
        ...(action.actionData.minToday
          ? {
              minfare: {
                minToday: action.actionData.minToday,
                minIn30Days: action.actionData.minIn30Days,
                minDepDateIn30Days: action.actionData.minDepDateIn30Days,
                todayDate: action.actionData.todayDate,
                minPriceIn90Days: action.actionData.minPriceIn90Days,
                minDepDateIn90Days: action.actionData.minDepDateIn90Days,
                minFareInYear: action.actionData.minFareInYear,
                minDepDateInYear: action.actionData.minDepDateInYear
              }
            }
          : null)
      };
    case SET_COMMON_FARE_RULES:
      return {
        ...state,
        commonFareRulesData: {
          ...state.commonFareRulesData,
          [action.actionData.id]: action.actionData.data
        }
      };
    case SET_BANNER_DETAILS:
      return {
        ...state,
        bannerDetails: action.actionData
      };
    case SET_SPECIAL_FARE_OPTIONS:
      return {
        ...state,
        specialFareOptions: action.actionData
      };
    case SET_SELECTED_FARE_IDENTIFIER:
      return {
        ...state,
        selectedFareIdentifier: action.actionData
      };
    case SET_EXPERIMENT_DETAILS:
      return {
        ...state,
        experimentDetails: [...state.experimentDetails, ...props]
      };
    case SET_EXPERIMENT_META_DATA:
      return {
        ...state,
        experimentMetaData: {
          ...state.experimentMetaData,
          ...props
        }
      };
    // city country
    case SORT_DESTINATIONS:
      return {
        ...state,
        sortSettings: {
          previousSortType: state.sortSettings.currentSort,
          isAscending: action.actionData.isAscending,
          currentSort: action.actionData.currentSort
        }
      };
    case SORT_FLIGHTS:
      return {
        ...state,
        sortFlightSettings: {
          previousSortType: state.sortSettings.currentSort,
          isAscending: action.actionData.isAscending,
          currentSort: action.actionData.currentSort
        }
      };
    case UPDATE_SEARCH_WIDGET_TRAVEL_DATE:
      return {
        ...state,
        searchWidget: {
          ...state.searchWidget,
          travelDate: action.actionData.travelDate
        }
      };
    case UPDATE_SEARCH_WIDGET_TRIP_DURATION:
      return {
        ...state,
        searchWidget: {
          ...state.searchWidget,
          tripDuration: action.actionData.tripDuration
        }
      };
    case UPDATE_SEARCH_WIDGET_ANY_TIME:
      return {
        ...state,
        searchWidget: {
          ...state.searchWidget,
          anyTime: action.actionData.anyTime
        }
      };
    case UPDATE_ANYWHERE:
      return {
        ...state,
        searchWidget: {
          ...state.searchWidget,
          isAnywhere: action.actionData.isAnywhere
        }
      };
    case UPDATE_SELECTED_DESTINATION:
      return {
        ...state,
        selectedDestination: action.actionData.selectedDestination
      };
    case UPDATE_DEPARTURE:
      return {
        ...state,
        departure: action.actionData.departure
      };
    case UPDATE_ARRIVAL:
      return {
        ...state,
        arrival: action.actionData.arrival
      };

    //thor
    case ADD_STATIC_INFORMATION:
      return {
        ...state,
        staticInformation: {
          ...state.staticInformation,
          ...action.actionData
        }
      };
    case UPDATE_THOR_HIT_ERR_MSG:
      return {
        ...state,
        errorMsg: action.actionData,
        receivedAllChunks: true,
        isStoreEmpty: false
      };
    case ADD_CORRELATION_ID_FOR_LOGGING:
      return {
        ...state,
        correlationIdForLogging: action.actionData
      };
    case SET_UUID: {
      return { ...state, ...props };
    }
    case SET_PRE_SEARCH_BANNER_DETAILS: {
      return {
        ...state,
        preSearchBannerDetails: action.actionData
      };
    }
    case SET_SELECTED_BANNER_DETAILS: {
      return {
        ...state,
        selectedBannerIndex: action.actionData
      };
    }
    default:
      return state;
  }
}
